<template>
  <section class="image-bg container-fluid py-6 py-md-8" id="fa-hero">
    <div class="row" id="company-overview">
      <FAsidenav />
      <div class="col-12 offset-md-3 col-md-8 col-lg-7 mb-4">
        <h1 class="white-text mb-3 load-anim" ref="headline">
          Independent Financial Advisory
        </h1>
        <h2 class="subhead gold-text mb-4 load-anim" ref="subhead">
          Sector Focused. Relationship Driven.
        </h2>
        <div ref="content" class="load-anim">
          <p>
            CS Capital Advisors provides corporate advisory, mergers &
            acquisitions, capital raising and restructuring services to the
            health care, hospitality and other commercial real estate industries
            and related service sectors. CSCA is one of the leading financial
            advisors to the seniors housing, skilled nursing and related senior
            care industries with an unparalleled transactions track record and
            network of industry relationships.
          </p>
          <p>
            Our history is deeply rooted in real estate given our early
            beginnings as the investment banking subsidiary of Cohen & Steers,
            Inc. (NYSE:CNS) from 1999 to 2009.
          </p>
          <p>
            With a proven long-term track record and creative approach to
            complex situations, we are the trusted adviser of choice to public
            and private company senior executives, boards and independent
            committees.
          </p>
        </div>
      </div>
      <div class="col-12 offset-md-3 col-md-8 col-lg-7">
        <div class="row">
          <div class="col-12 col-md-4 load-anim" ref="feature1">
            <h4 class="gold-text">Experienced</h4>
            <p>
              CSCA’s deep expertise in the healthcare real estate industry
              includes $75+ billion of advisory and banking transactions.
            </p>
          </div>
          <div class="col-12 col-md-4 load-anim" ref="feature2">
            <h4 class="gold-text">Long-Term Focus</h4>
            <p>
              20+ year proven long-term track record and creative approach
              enables CSCA to assists clients in all market cycles.
            </p>
          </div>
          <div class="col-12 col-md-4 load-anim" ref="feature3">
            <h4 class="gold-text">Client Loyalty</h4>
            <p>
              CSCA has an impressive 90% client retention rate. Repeat business
              is the best evidence of the success and the value we deliver to
              our clients.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FAsidenav from "@/components/FAsidenav.vue";
import { TimelineLite, Power2 } from "gsap";
export default {
  components: {
    FAsidenav
  },
  methods: {
    introAnim() {
      var introAnimEls = [];
      introAnimEls.push(this.$refs.headline);
      introAnimEls.push(this.$refs.subhead);
      introAnimEls.push(this.$refs.content);
      introAnimEls.push(this.$refs.feature1);
      introAnimEls.push(this.$refs.feature2);
      introAnimEls.push(this.$refs.feature3);
      introAnimEls.push(document.getElementById("fa-side-nav"));
      var t1 = new TimelineLite();
      t1.staggerTo(
        introAnimEls,
        1,
        { opacity: 1, transform: "translateY(0)", ease: Power2.easeOut },
        0.3,
        "-=0.2"
      );
    }
  },
  mounted() {
    this.introAnim();
  }
};
</script>

<style lang="scss" scoped>
#fa-hero {
  background-image: url(../assets/meeting-bg.jpg);
}
p {
  color: #ffffff;
}
h4 {
  font-size: 1.25rem;
  @media screen and (max-width: 900px) {
    font-size: 1.15rem;
  }
}
</style>
